import React, { useState } from "react";
import RadiologyLayout from "./RadiologyLayout";
import IpdRadiologyOrders from "./IpdRadiologyOrders";
import DiagnosticDoctorQueue from "../diagnostic-reports/DiagnosticDoctorQueue";
import { C } from "../ipd-billing/constants";
import { PageHeader } from "../rule-builder/ui";
import { usePermissions } from "../login/PermissionContext";
import { allowedPatientTypeTabs } from "../lab-technician/labOrdersShared";

function PatientTypeTabs({ value, onChange, allowedIds }) {
  const tabs = [
    { id: "ALL", label: "All" },
    { id: "OPD", label: "OPD" },
    { id: "IPD", label: "IPD" },
    { id: "EMERGENCY", label: "Emergency" },
  ].filter((t) => allowedIds.includes(t.id));
  return (
    <div
      style={{
        display: "inline-flex",
        gap: 4,
        background: "#eef1f4",
        borderRadius: 10,
        padding: 4,
        marginBottom: 20,
      }}
    >
      {tabs.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "8px 16px",
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
              fontFamily: "inherit",
              fontSize: 13,
              fontWeight: 700,
              background: active ? "#fff" : "transparent",
              color: active ? C.text : C.textSub,
              boxShadow: active ? "0 1px 3px rgba(13,35,63,0.12)" : "none",
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

function RadiologyTest() {
  const [patientTypeTab, setPatientTypeTab] = useState("ALL");
  const { userInfo } = usePermissions();
  const allowedTabs = allowedPatientTypeTabs(userInfo?.facility_type);
  // "ALL" is not offered to an OPD-only facility, same as the lab board.
  const activePatientTypeTab = allowedTabs.includes(patientTypeTab)
    ? patientTypeTab
    : allowedTabs[0];
  const isRadiologist =
    String(sessionStorage.getItem("roleType") || "").toLowerCase() ===
    "radiologist";

  return (
    <RadiologyLayout>
      {isRadiologist ? (
        <DiagnosticDoctorQueue />
      ) : (
        <div style={{ padding: "28px 32px" }}>
          <PageHeader
            title="Tests and Examinations"
            subtitle="Patient radiology orders · status tracking · report uploads"
          />

          <PatientTypeTabs
            value={activePatientTypeTab}
            onChange={setPatientTypeTab}
            allowedIds={allowedTabs}
          />

          <IpdRadiologyOrders patientTypeFilter={activePatientTypeTab} />
        </div>
      )}
    </RadiologyLayout>
  );
}

export default RadiologyTest;
